<div class="network-modal">
  <span class="color-red" l10nTranslate *ngIf="isDesktop && !status">InternetConnection.NoInternetConnection</span>
  <span class="color-red" l10nTranslate *ngIf="!isDesktop && !status">InternetConnection.InOfflineMode</span>
  <span class="color-green" l10nTranslate *ngIf="status">InternetConnection.Online</span>
  <ion-icon class="modal-icon" name="close-outline" (click)="dismiss()"></ion-icon>
</div>
